export const truncateText = (text: string | undefined, limit = 100): string =>
  text && text.length > limit ? text.slice(0, limit) + "..." : text ?? "";
